import { useState } from "react";
import { AlertTriangle, ArrowUpRight, RefreshCw } from "lucide-react";
import { Button } from "../ui/button";
import { RenewDialog } from "./RenewDialog";

const STATUS = {
  KEDALUWARSA: "bg-rose-600 text-white",
  "SEGERA HABIS": "bg-amber-500 text-white",
  "TIDAK VALID": "bg-slate-300 text-slate-700",
};

const fmt = (iso) => (/^\d{4}-\d{2}-\d{2}$/.test(iso) ? new Date(iso).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" }) : iso || "-");
const sisa = (d) => (d === null ? "-" : d < 0 ? `lewat ${-d} hari` : `${d} hari lagi`);

export const SenpiAlerts = ({ rows, days, onOpen, onRenewed }) => {
  const [renewing, setRenewing] = useState(null);
  const expired = rows.filter((r) => r.status === "KEDALUWARSA").length;
  const soon = rows.filter((r) => r.status === "SEGERA HABIS").length;
  const invalid = rows.filter((r) => r.status === "TIDAK VALID").length;
  return (
    <section className="border border-rose-200 bg-card" data-testid="senpi-alerts">
      <div className="px-5 py-4 border-b flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div className="flex items-start gap-3">
          <AlertTriangle className="h-5 w-5 text-rose-600 mt-0.5" />
          <div>
            <h2 className="font-heading font-bold text-base md:text-lg">Pengingat Surat Ijin Senpi</h2>
            <p className="text-xs text-muted-foreground mt-0.5">Surat ijin yang sudah habis atau habis dalam {days} hari ke depan</p>
          </div>
        </div>
        <div className="flex gap-2 text-xs font-semibold">
          <span className="px-2.5 py-1 bg-rose-600 text-white" data-testid="senpi-alert-expired-count">{expired} KEDALUWARSA</span>
          <span className="px-2.5 py-1 bg-amber-500 text-white" data-testid="senpi-alert-soon-count">{soon} SEGERA HABIS</span>
          {invalid > 0 && <span className="px-2.5 py-1 bg-slate-300 text-slate-700" data-testid="senpi-alert-invalid-count">{invalid} TANGGAL TIDAK VALID</span>}
        </div>
      </div>
      <div className="max-h-[360px] overflow-auto">
        <table className="w-full text-sm">
          <thead className="sticky top-0 bg-muted">
            <tr className="text-left border-b">
              <th className="px-5 py-2.5 eyebrow">Pemegang</th>
              <th className="hidden sm:table-cell px-3 py-2.5 eyebrow">Senpi / No. Seri</th>
              <th className="hidden sm:table-cell px-3 py-2.5 eyebrow">Berlaku S.D.</th>
              <th className="hidden sm:table-cell px-3 py-2.5 eyebrow">Sisa</th>
              <th className="px-3 sm:px-5 py-2.5 eyebrow">Status</th>
              <th className="px-3 sm:px-5 py-2.5 eyebrow text-right">Aksi</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.item_id} onClick={onOpen} className="border-b last:border-0 cursor-pointer hover:bg-muted/50 transition-colors group" data-testid={`senpi-alert-row-${r.item_id}`}>
                <td className="px-5 py-2.5"><div className="font-medium">{r.pj_nama || "-"}</div><div className="text-xs text-muted-foreground">{r.pj_pangkat}<span className="sm:hidden"> &middot; {r.merk_model}<span className="block font-mono">s.d. {fmt(r.berlaku_sd)}</span></span></div></td>
                <td className="hidden sm:table-cell px-3 py-2.5"><div>{r.merk_model}</div><div className="text-xs font-mono text-muted-foreground">{r.no_seri}</div></td>
                <td className="hidden sm:table-cell px-3 py-2.5 font-mono whitespace-nowrap">{fmt(r.berlaku_sd)}</td>
                <td className="hidden sm:table-cell px-3 py-2.5 whitespace-nowrap text-xs">{sisa(r.days_left)}</td>
                <td className="px-3 sm:px-5 py-2.5">
                  <span className="flex items-center gap-2">
                    <span className={`px-2 py-0.5 text-[11px] font-semibold rounded-sm whitespace-nowrap ${STATUS[r.status]}`}>{r.status}</span>
                    <ArrowUpRight className="hidden sm:block h-4 w-4 text-muted-foreground group-hover:text-primary transition-colors" />
                  </span>
                </td>
                <td className="px-3 sm:px-5 py-2 text-right">
                  <Button size="sm" variant="outline" className="h-8" data-testid={`renew-button-${r.item_id}`}
                    onClick={(e) => { e.stopPropagation(); setRenewing(r); }}>
                    <RefreshCw className="h-3.5 w-3.5" /> <span className="hidden sm:inline">Perbarui</span>
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <RenewDialog row={renewing} onClose={() => setRenewing(null)} onSaved={() => { setRenewing(null); onRenewed(); }} />
    </section>
  );
};
